import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface PublicSiteUrls {
  mainSiteURL?: string;
  rtkExpertSiteURL?: string;
}

@Injectable({ providedIn: 'root' })
export class PublicSiteConfigService {
  private readonly base = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  getSiteUrls(): Observable<PublicSiteUrls> {
    return this.http.get<PublicSiteUrls>(`${this.base}/public/site-urls`);
  }
}


